import { render, staticRenderFns } from "./villageAffairs.vue?vue&type=template&id=7ad95f02&scoped=true&"
import script from "./villageAffairs.vue?vue&type=script&lang=js&"
export * from "./villageAffairs.vue?vue&type=script&lang=js&"
import style0 from "./villageAffairs.vue?vue&type=style&index=0&id=7ad95f02&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ad95f02",
  null
  
)

export default component.exports